// Action extraction logic

// Action mappings for extraction
export const actions_en: Record<string, string[]> = {
  "deliver/supply": ["deliver", "delivered", "supply", "supplied"],
  "install/apply": ["install", "installed", "apply", "applied"], 
  "remove/break up": ["remove", "removed", "break up", "broken up"],
  "clean/flush": ["clean", "cleaned", "flush", "flushed"]
};

export type ActionKeyword = string | [string, string];

export const actions_nl: Record<string, ActionKeyword[]> = {
  "aanbrengen/installeren": [
    // aanbrengen (separable)
    "aanbrengen", "aangebracht",
    ["aan","breng"],     // ik breng ... aan
    ["aan","brengen"],   // wij brengen ... aan
    ["aan","bracht"],    // ik bracht ... aan
    ["aan","brachten"],  // wij brachten ... aan
    // installeren (inseparable)
    "installeren", "installeer", "installeerde", "installeerden", "geïnstalleerd",
    // common no-diacritics variant seen in data
    "geinstalleerd"
  ],

  "reinigen/doorspuiten": [
    // reinigen (inseparable)
    "reinigen", "reinig", "reinigde", "reinigden", "gereinigd",
    // doorspuiten (separable)
    "doorspuiten", "doorgespoten",
    ["door","spuit"],    // ik spuit ... door
    ["door","spuiten"],  // wij spuiten ... door
    ["door","spoot"],    // ik spoot ... door
    ["door","spoten"]    // wij spoten ... door
  ],

  "opbreken/verwijderen": [
    // opbreken (separable)
    "opbreken", "opgebroken",
    ["op","breek"],      // ik breek ... op
    ["op","breken"],     // wij breken ... op
    ["op","brak"],       // ik brak ... op
    ["op","braken"],     // wij braken ... op
    // verwijderen (inseparable)
    "verwijderen", "verwijder", "verwijderde", "verwijderden", "verwijderd"
  ],

  "vervoeren/leveren": [
    // vervoeren (inseparable)
    "vervoeren", "vervoer", "vervoerde", "vervoerden", "vervoerd",
    // leveren (inseparable)
    "leveren", "lever", "leverde", "leverden", "geleverd"
  ]
};


export function extract_actions(sentence: string, lang: string): string[] {
  const words = sentence.toLowerCase().split(/\s+/);
  const foundActions: string[] = [];
  

  
  for (const word of words) {
    const cleanWord = word.replace(/[.,!?;:]/g, '');
    
    // Check for exact word match in actions
    if (lang === 'en') {
      // For English: check if word exists in any of the action arrays
      for (const [category, actionWords] of Object.entries(actions_en)) {
        if (actionWords.includes(cleanWord)) {
          foundActions.push(category);
          break; // Found in this category, move to next word
        }
      }
    } else {
      // For Dutch: check both simple strings and separable verb pairs
      
      for (const [category, actionKeywords] of Object.entries(actions_nl)) {
        let foundInCategory = false;
        
        for (const keyword of actionKeywords) {
          
          if (typeof keyword === 'string') {
            // Simple string match
            if (keyword === cleanWord) {
              foundActions.push(category);
              foundInCategory = true;
              break;
            }
          } else if (Array.isArray(keyword) && keyword.length === 2) {
            // Separable verb pair - both parts must be present
            const [part1, part2] = keyword;
            if (cleanWord === part1 || cleanWord === part2) {
              // Check if the other part exists elsewhere in the sentence
              const otherPart = cleanWord === part1 ? part2 : part1;
              const sentenceWords = sentence.toLowerCase().split(/\s+/).map(w => w.replace(/[.,!?;:]/g, ''));
              
              if (sentenceWords.includes(otherPart)) {
                foundActions.push(category);
                foundInCategory = true;
                break;
              }
            }
          }
        }
        
        if (foundInCategory) {
          break; // Found in this category, move to next word
        }
      }
    }
    
    if (lang === 'en' && !foundActions.some(action => action === foundActions[foundActions.length - 1])) {
    } else if (lang === 'nl') {
      // Check if any action was found for this word
      let foundAnyAction = false;
      for (const [category, actionKeywords] of Object.entries(actions_nl)) {
        for (const keyword of actionKeywords) {
          if (typeof keyword === 'string' && keyword === cleanWord) {
            foundAnyAction = true;
            break;
          } else if (Array.isArray(keyword) && keyword.length === 2) {
            const [part1, part2] = keyword;
            if (cleanWord === part1 || cleanWord === part2) {
              const otherPart = cleanWord === part1 ? part2 : part1;
              const sentenceWords = sentence.toLowerCase().split(/\s+/).map(w => w.replace(/[.,!?;:]/g, ''));
              if (sentenceWords.includes(otherPart)) {
                foundAnyAction = true;
                break;
              }
            }
          }
        }
        if (foundAnyAction) break;
      }
      
      if (!foundAnyAction) {
      }
    }
  }
  
  
  // Remove duplicates and return unique actions
  const uniqueActions = foundActions.filter((action, index) => foundActions.indexOf(action) === index);
  return uniqueActions;
}
